import {IBaseLookup} from "./Ibase.lookup";

export namespace DocumentType {

    export const lookupName: string = "DocumentType";

    export interface DocumentType {
        documentTypeKey: number;
        name: string;
        active: string;
        lastUpdated: Date;
        autoTextTypeKey: number;
        reportTemplateTypeKey: number;
        distributionMask: string;
        code: string;
    }

    export interface DocumentTypeDS extends IBaseLookup {
        documentType: DocumentType[];
    }
}
